module.exports = __webpack_public_path__ + "static/img/12.4af8a1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/12.png
// module id = KVET
// module chunks = 0